/** Four-digit sign-in codes are shown as two pairs (`47 29`); the server accepts `dd dd` or `dddd`. */
export const SIGN_IN_CODE_LENGTH = 4;

/** Keep digits only and display them as `NN NN` while typing. */
export function formatSignInCode(raw: string): string {
  const digits = raw.replace(/[^0-9]/g, '').slice(0, SIGN_IN_CODE_LENGTH);
  return digits.length > 2 ? `${digits.slice(0, 2)} ${digits.slice(2)}` : digits;
}

/** True once all four digits are present, whatever the spacing. */
export function isCompleteSignInCode(value: string): boolean {
  return value.replace(/[^0-9]/g, '').length === SIGN_IN_CODE_LENGTH;
}
